module.exports = __webpack_public_path__ + "img/instagram.c0686aea.svg";